import { __ } from '@wordpress/i18n';
document.addEventListener("DOMContentLoaded", function () {
    function EmailHandling() {
        var _self = this;
        var _holder = "";
        var _url = "";
        var _id = "";

        this.init = function (holder, url) {
            _holder = holder;
            _url = url;
            _id = _holder.id;

            if (window.hasOwnProperty("awwwFormVars") && window.awwwFormVars.hasOwnProperty(_id)) {
                setNotifications(window.awwwFormVars[_id]);
            }

            var awwwpostidentifier = _holder.querySelector("[name='awwwpostidentifier']");
            if (awwwpostidentifier) {
                awwwpostidentifier.value = window.wp_vars.post_id;
            }

            this.close();

            _holder.querySelectorAll("button[type='submit'], input[type='submit']").forEach(function (submitBtn) {
                submitBtn.addEventListener('click', function (e) {
                    if (_holder.checkValidity()) {
                        e.preventDefault();
                        _holder.classList.add("form-sending");
                        
                        ajaxCall(getFormdata());
                        
                    } else {
                        submitBtn.closest("form").classList.add("awww-error");
                    }
                });
            });

            var event = new Event('AWWW_REINIT_FORM_SUBMITS');
            document.dispatchEvent(event);

            _initRange();
        };

        function _initRange() {
            _holder.querySelectorAll(".input-range").forEach(function (showstat) {
                var range = showstat.querySelector("input[type='range']");
                var value = showstat.querySelector('.range-slider__value');
                if (range && value) {
                    range.addEventListener('input', function () {
                        value.innerHTML = this.value;
                    });
                }
            });
        }

        this.close = function () {
            _holder.querySelectorAll("button[type='submit'], input[type='submit']").forEach(function (submitBtn) {
                submitBtn.removeEventListener('click', function () {});
            });
        };

        function getFormdata() {
            var multipleData = {};
            var formData = new FormData();
            formData.append("action", "awww_send_email");

            _holder.querySelectorAll("[name]").forEach(function (input) {
                if (input.type == "file") {
                    formData.append(input.name, input.files[0]);
                } else if (input.type == "checkbox" || input.type == "radio") {
                    if (input.checked) {
                        if (!multipleData[input.name]) {
                            multipleData[input.name] = [];
                        }
                        multipleData[input.name].push(input.value);
                    }
                } else {
                    formData.append(input.name, input.value);
                }
            });

            for (var name in multipleData) {
                formData.append(name, multipleData[name].toString());
            }

            return formData;
        }

        function ajaxCall(formData) {
            
            setNotifications({sendmail: __("Sending the email...", 'campthree')});
            
            fetch(_url, {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(results => {
                console.log(results);
                returnAjax(results);
                _holder.classList.remove("form-sending");
            })
            .catch(error => console.error('Error:', error));
        }

        function setNotifications(notifys) {
          
            _holder.reset();

            var classes = "";
            var msgs = "";

            for (var i in notifys) {
                classes += i + " ";
                msgs += notifys[i] + " ";
            }

            _holder.querySelector(".contactInfoHolder").classList.add(classes.trim());
            _holder.querySelector(".contactInfo").innerHTML = msgs.trim();
        }

        function returnAjax(results) {
           
            _holder.reset();

            var classes = "";
            var msgs = "";

            if (results.page_redirect) {
                var target = results.redirect_target || "_self";
                window.open(results.page_redirect, target);
            } else {
                _holder.querySelector(".contactInfoHolder").classList.add(results.state);
                _holder.querySelector(".contactInfo").innerHTML = results.msg;
            }
        }
    }

    function awwwActivateEmails() {
        document.querySelectorAll("form.wp-block-awww-contactform").forEach(function (form) {
            var emailing = new EmailHandling();
            emailing.init(form, ajaxRequirements.ajaxUrl);
        });

        document.querySelectorAll(".activatesteps").forEach(function (stepsHolder) {
            var steps = new AwwwStepsHandling();
            steps.init(stepsHolder);
        });
    }

    awwwActivateEmails();

    document.addEventListener("AWWW_MODAL_FILLED", awwwActivateEmails);
    document.addEventListener("AWWW_PAGE_RELOAD_FIRST", awwwActivateEmails);
});